import { stringify } from 'query-string';
import { DataProvider, fetchUtils } from 'ra-core';

const formatFilterOR = (filter) => {
    return Object.entries(filter)
        .map(([key, value], index) => {
            return { [`filter${index}`]: `${key},eq,${value}` };
        })
        .reduce((prev, current) => ({ ...prev, ...current }), {});
};

/**
 * append the result directly to the request url
 */
const formatFilterAND = (filter) => {
    return Object.entries(filter)
        .map(([key, value], _index) => {
            return `filter=${key},cs,${value}`;
        })
        .join("&");
};

const getDataProvider = (apiUrl, httpClient = fetchUtils.fetchJson) => ({
    getList: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="report_queue"){
            resource="queue";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        if(resource==="presensi_pojok"){
            resource="presensi_pojok";
        }
        if(resource==="presensi_ppid"){
            resource="presensi_ppid";
        }
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            order: `${field},${order}`,
            page: `${page},${perPage}`
        };
        const url = `${apiUrl}/records/${resource}?${stringify(query)}&${formatFilterAND(params.filter)}`;

        const { json } = await httpClient(url);
        return ({
            data: json.records,
            total: json.results ?? 0,
        });
    },

    getOne: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { json } = await httpClient(`${apiUrl}/records/${resource}/${params.id}`);
        return ({ data: json });
    },

    getMany: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const url = `${apiUrl}/records/${resource}/${params.ids.join(',')}`;
        const { json } = await httpClient(url);
        return ({ data: Array.isArray(json) ? json : [json] });
    },

    getManyReference: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            order: `${field},${order}`,
            page: `${page},${perPage}`,
        };
        
        const url = `${apiUrl}/records/${resource}?${stringify(query)}&${formatFilterAND(params.filter)}`;

        const { json } = await httpClient(url);
        return ({
            data: json.records,
            total: json.results,
        });
    },

    // TODO: update is not returning the record
    update: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        await httpClient(`${apiUrl}/records/${resource}/${params.id}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        });
        const { json } = await httpClient(`${apiUrl}/records/${resource}/${params.id}`);
        return ({
            data: json,
        });
    },

    // TODO: updateMany is not returning the records
    updateMany: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { json } = await httpClient(`${apiUrl}/records/${resource}/${params.ids.join(',')}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        });
        return ({ data: json });
    },

    create: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { json } = await httpClient(`${apiUrl}/records/${resource}`, {
            method: 'POST',
            body: JSON.stringify(params.data),
        });
        return ({
            data: { ...params.data, id: json },
        });
    },

    // TODO: delete is not returning the id
    delete: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { json } = await httpClient(`${apiUrl}/records/${resource}/${params.id}`, {
            method: 'DELETE',
        });
        return ({ data: json });
    },

    deleteMany: async (resource, params) => {
        if(resource==="survey"){
            resource="penilaian";
        }
        if(resource==="penilaian_piket"){
            resource="jadwal_piket";
        }
        if(resource==="penilaian_piket_ppid"){
            resource="jadwal_piket_ppid";
        }
        const { json } = await httpClient(`${apiUrl}/records/${resource}/${params.ids.join(',')}`, {
            method: 'DELETE',
        });
        return ({ data: Array.isArray(json) ? json : [json] });
    },
});

export default getDataProvider;